import {
  MessageEnvelope,
  MessagePayload,
} from '@zonofi/common/schema/message/inferface';
export interface ConversationListRequest {
  sellerWorkspaceId: string;
  limit: number;
  customerId?: string;
  lastEvaluatedTimeToken?: string;
  assigneeId?: string;
  category?: string;
  startDate?: string; // Start date for filtering (ISO string)
  endDate?: string; // End date for filtering (ISO string)
  assignedToMe?: boolean;
  conversationId?: string;
  lastEvaluatedConversationThreadId?: string;
  channelTypes?: string[];
  channelSubTypes?: string[];
  queryType?: string;
  teamMemberIds?: string[];
  tags?: string[];
}

export interface MediaRequest {
  fileName: string;
  type: string;
  userId?: string;
  contentType: string;
  destination: string;
  method: string;
  channelId?: string;
  messageId?: string;
}

export interface ConversationListResponse {
  success: boolean;
  data: ConversationData[];
  message: string;
  pagination: ConversationPagination;
}

export interface ConversationData {
  customerPhone?: string;
  metadata?: ConversationMetadata;
  lastMessageAt?: string;
  status?: string;
  isAssigned?: boolean;
  createdAt: string;
  conversationThreadId?: string;
  workspaceId: string;
  customerId: string | null;
  chatId?: string;
  isWidgetChat?: boolean;
  isRegisteredCustomer?: boolean;
  windowStartTime?: string;
  windowEndTime?: string;
  startMessageTimetoken?: string;
  endMessageTimetoken?: string;
  description?: string;
  channelType?: string;
  channelSubType?: string | null;
  queryType?: string;
  channelName?: string;
  isGroup?: boolean;
  channelId?: string;
  title?: string;
  updatedAt?: string;
  assignedTo?: ConversationAssignee[];
  widgetChat?: {
    customerLocation: string;
    referralSource: string;
    isWidgetChat: boolean;
    registrationStatus: string;
    sessionId: string;
  };
  customerLifeCyclePaths?: string[];
}

interface ConversationMetadata {
  tags?: string[];
  tag?: string[];
  customerType?: 'new' | 'new_lead';
  campaignName?: string;
  status?: string;
}

export interface ConversationPagination {
  hasMore: boolean;
  total: number;
  lastEvaluatedTimeToken?: string | null;
  lastEvaluatedConversationThreadId?: string | null;
}

interface NextCursor {
  lastMessageAt: string;
  startKey: string;
}

export interface UpdateConversationStatusRequest {
  sellerWorkspaceId: string;
  conversationId: string;
  status: string;
}

export interface UpdateConversationAssigneeRequest {
  sellerWorkspaceId: string;
  conversationId: string;
  teamMemberId: string;
  type?: UpdateConversationAssigneeType;
}

export enum UpdateConversationAssigneeType {
  ASSIGN = 'assign',
  WATCHER = 'watcher',
}

export interface ConversationAssignee {
  teamMemberName: string;
  teamMemberId: string;
  role?: string;
}

export interface UpdateConversationResponse {
  data: ConversationData;
  message: string;
  success: boolean;
}

export interface ConversationStatusResponse {
  statuses: Status[];
  workspaceId: string;
  totalCount: number;
}

export enum ConversationStatusGroup {
  OPEN = 'Open',
  INPROGRESS = 'InProgress',
  CLOSED = 'Close',
}

interface Status {
  status: string;
  category: ConversationStatusGroup;
}

export interface ConversationMessagesRequest {
  conversationId: string;
  sellerWorkspaceId: string;
}

export interface ConversationMessagesResponse {
  success: boolean;
  data: ConversationMessage[];
  message: string;
}

export enum MsgError {
  REENGAGEMENT_ERROR = 'REENGAGEMENT_ERROR',
}

export interface MsgStats {
  REENGAGEMENT_ERROR: {
    dateTime: string;
    description: string;
  };
  error: {
    dateTime: string;
    type: MsgError;
    description: 'Re-engagement message';
  };
}

export interface ConversationMessage {
  stats: MsgStats;
  pubnubMessage: MessagePayload;
  timetoken: string;
  customerId: string;
  isInternalNote?: boolean;
  chatId?: string;
  isWidgetChat?: boolean;
  message?: MessagePayload;
}

export interface MessageMediaRequest {
  fileName: string;
  type: string;
  method: 'GET' | 'PUT' | 'get' | 'put';
  channelId?: string;
  messageId?: string;
  contentType: string;
  userId?: string;
}

export interface PublishMessagePayload {
  sellerWorkspaceId: string;
  conversationId?: string;
  channelId?: string;
  inviteIds?: string[];
  message: MessagePayload;
  isInternalNote?: boolean;
}

export interface WaConfigData {
  id: string;
  createdDate: string;
  updatedDate: string;
  workspaceId: string;
  wabaId: string;
  whatsappPhoneNoId: null;
  whatsappPhoneNo: string;
  namespaceId: null;
  metaBusinessToken: null;
  provider: string;
  sid: null;
  qualityRating: string;
  messageLimit: number;
  isDefault: boolean;
  isShared: boolean;
  isDeleted: boolean;
  deletedAt: null;
  status: string;
  displayName: string;
  authCode: null;
  profilePic: null;
  projectId: string;
  isCoexistence: boolean;
  branch: string;
  tag: string;
  esLinkID: string;
  info: {
    step: string;
    message: string;
  };
  isCatalogueSyncEnable: boolean;
}

export interface UpdateConversationTagsRequest {
  tags: string[];
  workspaceId: string;
  conversationId: string;
}

export interface UpdateConversationTagsResponse {
  tags: string[];
  conversationId: string;
  totalCount: number;
}

export interface SingleMessageRequest {
  messageId: string;
  workspaceId: string;
  channelId: string;
  sellerWorkspaceId: string;
}

export interface SingleMessageResponse {
  data: any;
  success: boolean;
}

export interface RedingtonMediaRequest {
  id: string;
  waConfigId: string;
  workspaceId: string;
}

export interface GetConversationQueryTypesRequest {
  params: {
    sellerWorkspaceId: string;
    startTime: string;
    endTime: string;
    pageNo: number;
    pageSize: number;
  };
}

export interface GetConversationQueryTypesResponse {
  data: ConversationQueryType[];
  pagination: {
    pageNo: number;
    pageSize: number;
    total: number;
    lastUpdatedAt: string;
  };
}

export interface ConversationQueryType {
  createdAt?: string;
  workspaceId?: string;
  queryType: string;
  description: string;
  icon: string;
  color: string;
  updatedAt: string;
  conversationThreads: {
    data: ConversationThread[];
    pagination: {
      hasMore: boolean;
      nextCursor: string;
      total: number;
    };
  };
}

export interface ConversationThread {
  startMessageTimetoken: string;
  title: string;
  conversationId: string;
  endTime?: string;
  participantNames?: string[];
  endMessageTimetoken: string;
  startTime?: string;
  classificationType?: string;
  customerIds?: string[];
  messageCount?: number;
  createdAt?: string;
  channelId: string;
  channelName: string;
  participantIds?: string[];
  customerId?: string;
  windowId?: string;
  workspaceId: string;
  queryType?: string;
  backgroundColor?: string;
}

export interface GetConversationQueryDetailsRequest {
  params: {
    sellerWorkspaceId: string;
    startTime: string;
    endTime: string;
    queryType: string;
    limit?: number;
    lastEvaluatedConversationThreadId?: string;
    lastEvaluatedStartMessageTimetoken?: string;
  };
}

export interface GetConversationQueryDetailsResponse {
  data: ConversationThread[];
  pagination: {
    hasMore: boolean;
    nextCursor: string;
    total: number;
    lastEvaluatedConversationThreadId?: string;
    lastEvaluatedStartMessageTimetoken?: string;
  };
}

export interface ConversationQueryPagination {
  hasMore: boolean;
  nextCursor: string;
  total: number;
  lastEvaluatedConversationThreadId?: string;
  lastEvaluatedStartMessageTimetoken?: string;
}

export interface MessageHistoryRequest {
  startTimeToken: string;
  endTimeToken: string;
  workspaceId?: string;
  channelId?: string;
  limit?: number;
}

export interface MessagePaginationNextKey {
  channelId: string;
  sid: string;
  timetoken: string;
}

export interface MessageHistoryPagination {
  count: number;
  nextKey: MessagePaginationNextKey | null;
}

export interface MessageHistoryResponse {
  success: boolean;
  data: MessageEnvelope[];
  pagination: MessageHistoryPagination;
  message: string;
}

export type RelativeTimeRange =
  | 'LAST_24_HOURS'
  | 'LAST_3_DAYS'
  | 'LAST_7_DAYS'
  | 'LAST_15_DAYS'
  | 'LAST_30_DAYS'
  | 'LAST_60_DAYS';
